// extracted by mini-css-extract-plugin
module.exports = {"brandTrendingWrap":"gn-z"};